import {BaseContainerModel} from '../base-container.model';
import {bl_applet_catalog_hdr_RowClass, bl_applet_to_catalog_link_RowClass} from '../../dbschema/index';
import {bl_apple_catalog_line_RowClass} from '../../dbschema/bl_applet_catalog_line.model';
import {bl_applet_catalog_ext_RowClass} from '../../dbschema/bl_applet_catalog_ext.model';
import {bl_applet_catalog_event_RowClass} from '../../dbschema/bl_applet_catalog_event.model';

export class CatalogContainerModel extends BaseContainerModel {
  bl_applet_catalog_hdr: bl_applet_catalog_hdr_RowClass = new bl_applet_catalog_hdr_RowClass();
  bl_applet_catalog_lines: bl_apple_catalog_line_RowClass[] = [];
  bl_applet_catalog_exts: bl_applet_catalog_ext_RowClass[] = [];
  bl_applet_catalog_events: bl_applet_catalog_event_RowClass[] = [];
  bl_applet_to_catalog_links: bl_applet_to_catalog_link_RowClass[] = [];

}
